module.exports = __webpack_public_path__ + "img/settings.e84441b5.png";